module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Semibold.ffa8ecd69b45bd82cfa192d52bd6955b.eot";